import React, { useEffect, useState } from "react";
import { AddDocumentModal } from "../../components/reusableComponents/AddDocumentModal";
import { AddInterviewModal } from "../../components/reusableComponents/AddInterviewModal";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";
import { AddOpportunityModal } from "../../components/reusableComponents/AddOpportunityModal";
import { AddContractModal } from "../../components/reusableComponents/AddContractModal";
import { AddPayslipModal } from "../../components/reusableComponents/AddPayslipModal";
import { ActivateCandidateModal } from "../../components/reusableComponents/ActivateCandidateModal";
import { AdvancePaymentModal } from "../../components/reusableComponents/AdvancePaymentModal";
import { ReferenceCheckModal } from "../../components/reusableComponents/ReferenceCheckModal";
import { SendToFreelanceModal } from "../../components/reusableComponents/SendToFreelanceModal";
import { SickLeaveModal } from "../../components/reusableComponents/SickLeaveModal";
import { AddAtdModal } from "../../components/reusableComponents/AddAtdModal";
import { PlacementContractModal } from "../../components/reusableComponents/PlacementContractModal";
import { EditProfileModal } from "../../components/reusableComponents/EditProfileModal";
import { AddRatingModal } from "../../components/reusableComponents/AddratingModal";
import Modal from "../../components/reusableComponents/Modal";
import DocumentSection from "./DocumentSection";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../axios/AxiosInstance";
import { Loader2 } from "lucide-react";
import { countries } from "../../utils/countries";
import AvailableTable from "./AvailableTable";
import CandidateComment from "./CandidateComment";
import CandidatContract from "./CandidateContract";

export const CandidateModal = ({
  isOpen,
  onClose,
  candidate,
  candidates,
  setCandidates,
}) => {
  // Tabs state
  const [activeTab, setActiveTab] = useState("profile");
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [entretien, setEntretien] = useState([]);
  const [activeCandidate, setActiveCandidate] = useState({ ...candidate });

  // Modal states
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [isAddInterviewModalOpen, setIsAddInterviewModalOpen] = useState(false);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
  const [isAddOpportunityModalOpen, setIsAddOpportunityModalOpen] =
    useState(false);
  const [isAddRatingModalOpen, setIsAddRatingModalOpen] = useState(false);
  const [isAddContractModalOpen, setIsAddContractModalOpen] = useState(false);
  const [isAddPayslipModalOpen, setIsAddPayslipModalOpen] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [isAdvancePaymentModalOpen, setIsAdvancePaymentModalOpen] =
    useState(false);
  const [isReferenceCheckModalOpen, setIsReferenceCheckModalOpen] =
    useState(false);
  // Données liées aux acomptes
  const [advancePayments, setAdvancePayments] = useState([]);
  const [formData, setFormData] = useState({ ...candidate });
  const [isSendToFreelanceModalOpen, setIsSendToFreelanceModalOpen] =
    useState(false);
  const [isSickLeaveModalOpen, setIsSickLeaveModalOpen] = useState(false);
  const [isAddAtdModalOpen, setIsAddAtdModalOpen] = useState(false);
  const [isPlacementContractModalOpen, setIsPlacementContractModalOpen] =
    useState(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);

  // Action select state
  const [selectedAction, setSelectedAction] = useState("");
  const [showNet, setShowNet] = useState(false); // Etat pour basculer entre brut et net


  useEffect(() => {
  if (candidate) {
    setFormData({ ...candidate });
    setActiveCandidate({ ...candidate });
  }
}, [candidate]);

  useEffect(() => {
    getEntretien();
  }, []);

  // Formatage de l'expérience
  const formatExperience = (years) => {
    if (years === 0) return "Débutant";
    if (years === 1) return "1 an d'expérience";
    return `${years} ans d'expérience`;
  };

  const getEntretien = () => {
    axios
      .get(`entretien/${candidate._id}`)
      .then((res) => setEntretien(res.data))
      .catch((e) => {
        console.log(e);
      });
  };

  const handleToggleSalary = () => {
    setShowNet(!showNet); // Inverse la valeur de showNet
  };

  // Formatage de la date au format français
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ""; 
    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const updateCandidate = async () => {
    setLoadingUpdate(true);
    try {
      // Envoi de la requête de mise à jour au serveur
      const { data } = await axios.post(
        `tempworker-candidate/${candidate._id}/update`,
        formData,
      );
      // Affichage de la notification de succès
      toast.success("Modifications enregistrées !");
      // Mise à jour des candidats dans l'état
      setCandidates((prevCandidates) =>
  prevCandidates.map((c) =>
    c._id === candidate._id ? { ...c, ...formData } : c
  )
);

setActiveCandidate({ ...formData });
    } catch (error) {
      // Gestion des erreurs
      console.error("Error updating candidate: ", error);
      toast.error("Une erreur s'est produite !");
    }
    setLoadingUpdate(false);
  };

  const formatDateForInput = (date) => {
    const newDate = new Date(date);
    if (newDate instanceof Date) {
      const year = newDate.getFullYear();
      const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
      const day = newDate.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const setYearlySalary = (value) => {
    const parsed = parseFloat(value);

    if (value === "" || isNaN(parsed)) {
      setFormData((prevData) => ({
        ...prevData,
        yearlySalaryExpectations: "",
        monthlySalaryExpectations: "",
        dailySalaryExpectations: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        yearlySalaryExpectations: parsed,
        monthlySalaryExpectations: parsed / 12,
        dailySalaryExpectations: parsed / 12 / 151.67, // ex: 21.67 jours ouvrés/mois
      }));
    }
  };

  /*   const setMonthlySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12).toFixed(2))
      setMonthlySal(value)
      setDailySal((parseFloat(value) / 151.67).toFixed(2))
    }
  }

  const setDailySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12 * 151.67).toFixed(2))
      setMonthlySal((parseFloat(value) * 151.67).toFixed(2))
      setDailySal(value)
    }
  } */

  // Définition des onglets
  const tabs = [
    { id: "profile", label: "Profil" },
    { id: "documents", label: "Documents" },
    { id: "availability", label: "Disponibilité" },
    { id: "interviews", label: "Entretiens" },
    { id: "comments", label: "Commentaires" },
    { id: "opportunities", label: "Pressenti" },
    { id: "contracts", label: "Contrats" },
    { id: "payments", label: "Paie" },
    { id: "ratings", label: "Notations" },
  ];

  if (!candidate) {
    return <></>; // ou `null` si tu préfères
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-8/12 h-[85%]">
      <div className="flex justify-between items-center mb-4">
        <div className="flex w-full justify-between">
          <p className="text-3xl mb-0 capitalize font-semibold">
            {activeCandidate.firstname + " " + activeCandidate.lastname}
          </p>

          <select
            className="px-3 w-40  border text-center uppercase text-sm font-semibold  rounded-md text-white bg-black focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            value={selectedAction}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedAction(value);
              switch (value) {
                case "activer":
                  setIsAddDocumentModalOpen(true);
                  break;
                case "acompte":
                  setIsAddCommentModalOpen(true);
                  break;
                case "controle-reference":
                  setIsAddOpportunityModalOpen(true);
                  break;
                case "entretien":
                  setIsAddInterviewModalOpen(true);
                  break;
                case "freelance":
                  setIsAddInterviewModalOpen(true);
                  break;
                case "arret":
                  setIsAddInterviewModalOpen(true);
                  break;
              }
            }}
          >
            <option value="">Actions</option>
            <option value="activer">Activer le compte</option>
            <option value="acompte">Faire un acompte</option>
            <option value="controle-reference">Contrôle de réference</option>
            <option value="entretien">Créer un rdv entretien</option>
            <option value="freelance">Envoyer à freelance</option>
            <option value="arret">Ajouter un arret maladie</option>
          </select>
        </div>
      </div>

      <div className="space-y-6">
        {/* Tabs navigation */}
        <div className="border-b border-gray-200">
          <div className="flex overflow-x-auto justify-between pb-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`px-4 py-2 text-sm font-medium mr-2 ${activeTab === tab.id ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab content */}
        <div>
          {activeTab === "profile" && (
            <div className="space-y-6">
              {/* En-tête avec informations principales */}
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-shrink-0">
                  {candidate.image ? (
                    <img
                      src={`data:image/jpeg;base64,${candidate.image}`}
                      alt={`${candidate.firstname} ${candidate.lastname}`}
                      className="w-32 h-32 rounded-full object-cover border-2 border-gray-200"
                    />
                  ) : (
                    <div className="w-32 h-32 uppercase rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-2xl font-bold">
                      {activeCandidate.firstname.charAt(0)}
                      {activeCandidate.lastname.charAt(0)}
                    </div>
                  )}
                </div>

                <div className="flex-grow space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {candidate.jobTitle}
                    </h3>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${candidate.status === "Disponible" ? "bg-green-100 text-green-800" : candidate.status === "busy" ? "bg-orange-100 text-orange-800" : "bg-purple-100 text-purple-800"}`}
                    >
                      {candidate.status === "Disponible"
                        ? "Disponible"
                        : candidate.status}
                    </span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="flex items-center text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                      {candidate.phone}
                    </div>

                    <div className="flex items-center text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      {candidate.town}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                      {candidate.email}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8c-2.21 0-4-1.12-4-2.5S9.79 3 12 3s4 1.12 4 2.5S14.21 8 12 8zm0 0v8m0 0c2.21 0 4 1.12 4 2.5S14.21 21 12 21s-4-1.12-4-2.5S9.79 16 12 16z"
                        />
                      </svg>

                      <p className="mb-0">Tempo : {candidate.pld}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Séparateur */}
              <hr className="border-gray-200" />

              {/* Sections détaillées */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Informations personnelles */}
                <div className="space-y-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">
                    Informations personnelles
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Prénom */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="firstname"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Prénom :
                      </label>
                      <input
                        id="firstname"
                        type="text"
                        name="firstname"
                        value={formData.firstname || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Nom */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="lastname"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Nom :
                      </label>
                      <input
                        id="lastname"
                        type="text"
                        name="lastname"
                        value={formData.lastname || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Adresse */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="address"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Adresse :
                      </label>
                      <input
                        id="address"
                        type="text"
                        name="address"
                        value={formData.address || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Code postal */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="postCode"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Code postal :
                      </label>
                      <input
                        id="postCode"
                        type="text"
                        name="postCode"
                        value={formData.postCode || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Ville */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="town"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Ville :
                      </label>
                      <input
                        id="town"
                        type="text"
                        name="town"
                        value={formData.town || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Date de naissance */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="dob"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Date de naissance :
                      </label>
                      <input
                        id="dob"
                        type="date"
                        name="dob"
                        value={formatDateForInput(formData.dob)}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Nationalité */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="nationality"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        Nationalité :
                      </label>
                      <select
                        id="nationality"
                        name="nationality"
                        value={formData.nationality || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 pt-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      >
                        <option value="" disabled>
                          Choisir une nationalité
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Numéro de sécurité sociale */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="securityNumber"
                        className="text-gray-700 text-sm font-medium mb-2"
                      >
                        N° de sécurité sociale :
                      </label>
                      <input
                        id="securityNumber"
                        type="text"
                        name="securityNumber"
                        value={formData.securityNumber || ""}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>
                  </div>
                </div>

                {/* Informations professionnelles */}
                <div className="space-y-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">
                    Informations professionnelles
                  </h4>

                  {/* Qualification */}

                  <div className="space-y-4">
                    <div>
                      <span className="text-gray-700 mb-0 text-sm font-medium mr-2">
                        Qualifications:
                      </span>
                      <div className="flex mt-0 justify-between items-start">
                        <div className="text-gray-800 text-sm flex flex-wrap gap-2">
                          {formData.qualifications &&
                            formData.qualifications.map((qualif, index) => {
                              // Fonction pour générer une couleur pastel aléatoire
                              const randomColor = () => {
                                const hue = Math.floor(Math.random() * 360); // Génère une teinte aléatoire
                                const saturation = "70%"; // Saturation fixe
                                const lightness = "85%"; // Luminosité fixe pour une couleur pastel
                                return `hsl(${hue}, ${saturation}, ${lightness})`; // Retourne la couleur au format HSL
                              };

                              return (
                                <span
                                  key={index}
                                  className="rounded-full bg-blue-200 text-blue-700 px-3 py-1 text-xs font-semibold"
                                >
                                  {qualif}
                                </span>
                              );
                            })}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        Date d'inscription:
                      </span>
                      <span className="text-gray-800 font-medium">
                        {formatDate(formData.createdAt)}
                      </span>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        Disponibilité:
                      </span>
                      <select
                        name="status"
                        value={formData.status || ""}
                        onChange={handleChange}
                        className="w-60 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      >
                        <option value="" disabled>
                          Mobilité
                        </option>{" "}
                        {/* Option par défaut */}
                        <option value="Disponible">Disponible</option>
                        <option value="Indisponible">Indisponible</option>
                        <option value="Bloqué">Bloqué(e)</option>
                        <option value="Supprimé">Supprimé(e)</option>
                      </select>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        Mobilité:
                      </span>
                      <select
                        name="locomotions"
                        value={formData.locomotions || ""}
                        onChange={handleChange}
                        className="w-60 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      >
                        <option value="" disabled>
                          Choisir un statut
                        </option>{" "}
                        {/* Option par défaut */}
                        <option value="Transport en commun">
                          Transport en commun
                        </option>
                        <option value="Voiture">Voiture</option>
                        <option value="Moto">Moto</option>
                        <option value="Vélo/Trottinette">
                          Vélo/Trottinette
                        </option>
                      </select>
                    </div>

                    {/* Toggle brut/net */}
                    <div className="flex justify-end">
                      <button
                        onClick={handleToggleSalary}
                        className="ml-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-150 ease-in-out"
                      >
                        {showNet ? "Voir brut" : "Voir net"}
                      </button>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        {showNet ? "Taux horaire net:" : "Taux horaire brut:"}
                      </span>
                      <div className="flex items-center">
                        <input
                          type="text"
                          name="dailySalaryExpectations"
                          value={
                            showNet
                              ? (
                                  formData.dailySalaryExpectations * 0.78
                                ).toFixed(2)
                              : formData.dailySalaryExpectations
                          }
                          onChange={handleChange}
                          className="w-60 border text-right border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                        />
                      </div>
                    </div>

                    {/* Salaire mensuel */}
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        {showNet
                          ? "Salaire mensuel net:"
                          : "Salaire mensuel brut:"}
                      </span>
                      <input
                        type="text"
                        name="monthlySalaryExpectations"
                        value={
                          showNet
                            ? (
                                formData.monthlySalaryExpectations * 0.78
                              ).toFixed(2)
                            : formData.monthlySalaryExpectations
                        }
                        onChange={handleChange}
                        className="w-60 border text-right border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    {/* Salaire annuel */}
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 text-sm font-medium">
                        {showNet
                          ? "Salaire annuel net:"
                          : "Salaire annuel brut:"}
                      </span>
                      <input
                        type="text"
                        name="yearlySalaryExpectations"
                        value={
                          showNet
                            ? (
                                formData.yearlySalaryExpectations * 0.78
                              ).toFixed(2)
                            : formData.yearlySalaryExpectations
                        }
                        onChange={(e) => setYearlySalary(e.target.value)}
                        className="w-60 border text-right border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Bouton Enregistrer */}
              <div className="flex w-full justify-end mt-8">
                <button
                  onClick={updateCandidate}
                  className="px-6 py-2 bg-blue-600 flex justify-center items-center w-48 text-white rounded-md transition duration-150 ease-in-out"
                >
                  {loadingUpdate ? (
                    <Loader2 className="animate-spin h-6 w-6 text-white" />
                  ) : (
                    <span>Enregistrer</span>
                  )}
                </button>
              </div>

              {/* Notes internes */}
              <div>
                <h4 className="text-md font-semibold text-gray-900 mb-2">
                  Notes internes
                </h4>
                <div className="bg-gray-50 p-3 rounded-md text-gray-700">
                  {candidate.notes || "Aucune note disponible."}
                </div>
              </div>
            </div>
          )}

          {activeTab === "documents" && (
            <DocumentSection candidate={candidate} />
          )}

          {activeTab === "availability" && (
            <div className="space-y-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Disponibilité
                </h3>
                {/* <button className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Mettre à jour
                </button> */}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h4 className="font-medium text-gray-800 mb-2">
                    Statut actuel
                  </h4>
                  <div className="flex items-center">
                    <span
                      className={`inline-block w-3 h-3 rounded-full mr-2 ${candidate.status === "Disponible" ? "bg-green-500" : "bg-orange-500"}`}
                    ></span>
                    <span className="text-gray-700">{candidate.status}</span>
                  </div>
                  <p className="mt-2 text-gray-600">
                    Dernière mise à jour : {formatDate(candidate.createdAt)}
                  </p>
                </div>

                {/*   <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h4 className="font-medium text-gray-800 mb-2">
                    Disponibilité
                  </h4>
                  <p className="text-gray-700">{candidate.availability}</p>
                </div> */}

                {/*   <div className="bg-white p-4 rounded-lg border border-gray-200 col-span-1 md:col-span-2">
                  <h4 className="font-medium text-gray-800 mb-2">Mobilité</h4>
                  <p className="text-gray-700">{candidate.mobility}</p>
                </div> */}
              </div>

              {/* Tableau de disponibilité */}
              <div className="bg-white p-4 rounded-lg border border-gray-200">
                <h4 className="font-medium text-gray-800 mb-3">
                  Disponibilité hebdomadaire
                </h4>
                <div className="overflow-x-auto">
                  <AvailableTable
                    candidate={candidate}
                    candidates={candidates}
                    setCandidates={setCandidates}
                  />
                </div>
                {/*  <div className="mt-3 flex justify-end">
                  <button className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700">
                    Enregistrer les disponibilités
                  </button>
                </div> */}
              </div>
              {/* 
              <div className="bg-white p-4 rounded-lg border border-gray-200">
                <h4 className="font-medium text-gray-800 mb-3">
                  Historique des disponibilités
                </h4>
                <div className="space-y-3">
                  <div className="border-l-2 border-green-500 pl-3">
                    <p className="font-medium">Disponible</p>
                    <p className="text-sm text-gray-600">
                      À partir du 15/03/2025
                    </p>
                    <p className="text-xs text-gray-500">
                      Mise à jour le 28/02/2025
                    </p>
                  </div>
                  <div className="border-l-2 border-orange-500 pl-3">
                    <p className="font-medium">En mission</p>
                    <p className="text-sm text-gray-600">
                      Du 01/01/2025 au 15/03/2025
                    </p>
                    <p className="text-xs text-gray-500">
                      Mise à jour le 15/12/2024
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          )}

          {activeTab === "interviews" && (
            <div className="space-y-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Entretiens
                </h3>
                <button
                  className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
                  onClick={() => setIsAddInterviewModalOpen(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Planifier un entretien
                </button>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                {entretien.length === 0 && (
                  <div className="p-6 text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12 w-12 text-gray-400 mx-auto mb-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <p className="text-gray-600">Aucun entretien planifié</p>
                  </div>
                )}

                {entretien.length > 0 && (
                  <table className="min-w-full bg-white border border-gray-200">
                    <thead className="text-xs font-medium text-gray-700 uppercase bg-gray-100">
                      <tr>
                        <th className="px-4 py-2 text-left">Date</th>
                        <th className="px-4 py-2 text-left">Heure</th>
                        <th className="px-4 py-2 text-left">Client</th>
                        <th className="px-4 py-2 text-left">Poste</th>
                        <th className="px-4 py-2 text-left">Lieu</th>
                        <th className="px-4 py-2 text-left">Statut</th>
                        <th className="px-4 py-2 text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm text-gray-600">
                      {entretien.map((interview, index) => (
                        <tr key={index} className="border-t hover:bg-gray-50">
                          <td className="px-4 py-3">
                            {new Date(interview.date).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-3">
                            {new Date(interview.date).toLocaleTimeString()}
                          </td>
                          <td className="px-4 py-3">
                            {interview.client.companyName}
                          </td>
                          <td className="px-4 py-3">{interview.poste}</td>
                          <td className="px-4 py-3">{interview.place}</td>
                          <td className="px-4 py-3">
                            <span
                              className={`px-2 py-1 rounded-full text-xs ${
                                interview.status === "Completed"
                                  ? "bg-green-100 text-green-700"
                                  : interview.status === "Scheduled"
                                    ? "bg-blue-100 text-blue-700"
                                    : "bg-yellow-100 text-yellow-700"
                              }`}
                            >
                              {interview.status}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button
                              className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded"
                              title="Télécharger"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                />
                              </svg>
                            </button>

                            <button
                              className="p-1.5 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded"
                              title="Supprimer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

          {activeTab === "comments" && (
            <CandidateComment
              candidate={candidate}
              setCandidates={setCandidates}
              candidates={candidates}
            />
          )}

          {activeTab === "opportunities" && (
            <div className="space-y-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Candidatures & Missions pressenties
                </h3>
                <button
                  className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
                  onClick={() => setIsAddOpportunityModalOpen(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Ajouter une candidature
                </button>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="p-6 text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-gray-400 mx-auto mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <p className="text-gray-600">
                    Aucune opportunité pour le moment
                  </p>
                </div>
              </div>

              {/* Exemple d'une candidature ajoutée (en commentaire pour référence) */}
              {/* 
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden divide-y divide-gray-200">
                <div className="p-4 hover:bg-gray-50">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <h4 className="font-medium text-gray-900">Développeur Frontend React</h4>
                      <p className="text-sm text-gray-600">TechSolutions SAS</p>
                    </div>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">Entretien planifié</span>
                  </div>
                  <div className="mt-2 text-sm text-gray-600">
                    <p><span className="font-medium">Taux horaire:</span> 35€/h</p>
                    <p><span className="font-medium">Période:</span> 01/05/2025 - 31/07/2025</p>
                  </div>
                  <div className="mt-2 flex justify-end">
                    <button className="text-sm text-blue-600 hover:text-blue-800">Voir détails</button>
                  </div>
                </div>
              </div>
              */}
            </div>
          )}

          {activeTab === "contracts" && (
            <CandidatContract candidate={candidate} />
          )}

          {activeTab === "payments" && (
            <div className="space-y-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">Paie</h3>
                <button
                  className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
                  onClick={() => setIsAddPayslipModalOpen(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Ajouter un bulletin
                </button>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="p-6 text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-gray-400 mx-auto mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p className="text-gray-600">
                    Aucun bulletin de paie disponible
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === "ratings" && (
            <div className="space-y-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Évaluations
                </h3>
                <button
                  className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
                  onClick={() => setIsAddRatingModalOpen(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Ajouter une évaluation
                </button>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="p-6 text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-gray-400 mx-auto mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    />
                  </svg>
                  <p className="text-gray-600">Aucune évaluation disponible</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <AddDocumentModal
        isOpen={isAddDocumentModalOpen}
        onClose={() => setIsAddDocumentModalOpen(false)}
        onSave={(documentData) => {
          // Ajouter le document à la liste des documents du candidat
          console.log("Document ajouté:", documentData);
          setIsAddDocumentModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      {isAddInterviewModalOpen && (
        <AddInterviewModal
          isOpen={isAddInterviewModalOpen}
          onClose={() => setIsAddInterviewModalOpen(false)}
          candidate={candidate}
        />
      )}

      <AddOpportunityModal
        isOpen={isAddOpportunityModalOpen}
        onClose={() => setIsAddOpportunityModalOpen(false)}
        onSave={(opportunityData) => {
          console.log("Candidature ajoutée:", opportunityData);
          setIsAddOpportunityModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <AddRatingModal
        isOpen={isAddRatingModalOpen}
        onClose={() => setIsAddRatingModalOpen(false)}
        onSave={(ratingData) => {
          console.log("Évaluation ajoutée:", ratingData);
          setIsAddRatingModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <AddContractModal
        isOpen={isAddContractModalOpen}
        onClose={() => setIsAddContractModalOpen(false)}
        onSave={(contractData) => {
          console.log("Contrat créé:", contractData);
          setIsAddContractModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <AddPayslipModal
        isOpen={isAddPayslipModalOpen}
        onClose={() => setIsAddPayslipModalOpen(false)}
        onSave={(payslipData) => {
          console.log("Bulletin de paie ajouté:", payslipData);
          setIsAddPayslipModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <ActivateCandidateModal
        isOpen={isActivateModalOpen}
        onClose={() => setIsActivateModalOpen(false)}
        onSave={(data) => {
          console.log("Candidat activé:", data);
          setIsActivateModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <AdvancePaymentModal
        isOpen={isAdvancePaymentModalOpen}
        onClose={() => setIsAdvancePaymentModalOpen(false)}
        onSave={(data) => {
          console.log("Acompte effectué:", data);
          // Ajouter le nouvel acompte à la liste
          if (data.recurring) {
            setAdvancePayments((prev) => [
              ...prev,
              {
                ...data,
                id: `advance-${Date.now()}`,
                createdAt: new Date().toISOString(),
              },
            ]);
          }
          setIsAdvancePaymentModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <ReferenceCheckModal
        isOpen={isReferenceCheckModalOpen}
        onClose={() => setIsReferenceCheckModalOpen(false)}
        onSave={(data) => {
          console.log("Contrôle de référence effectué:", data);
          setIsReferenceCheckModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <SendToFreelanceModal
        isOpen={isSendToFreelanceModalOpen}
        onClose={() => setIsSendToFreelanceModalOpen(false)}
        onSave={(data) => {
          console.log("Candidat envoyé en freelance:", data);
          setIsSendToFreelanceModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <SickLeaveModal
        isOpen={isSickLeaveModalOpen}
        onClose={() => setIsSickLeaveModalOpen(false)}
        onSave={(data) => {
          console.log("Arrêt maladie déclaré:", data);
          setIsSickLeaveModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <AddAtdModal
        isOpen={isAddAtdModalOpen}
        onClose={() => setIsAddAtdModalOpen(false)}
        onSave={(data) => {
          console.log("ATD ajouté:", data);
          setIsAddAtdModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <PlacementContractModal
        isOpen={isPlacementContractModalOpen}
        onClose={() => setIsPlacementContractModalOpen(false)}
        onSave={(data) => {
          console.log("Contrat de placement créé:", data);
          setIsPlacementContractModalOpen(false);
        }}
        candidateId={candidate.id}
      />

      <EditProfileModal
        isOpen={isEditProfileModalOpen}
        onClose={() => setIsEditProfileModalOpen(false)}
        onSave={(data) => {
          console.log("Profil modifié:", data);
          setIsEditProfileModalOpen(false);
        }}
        candidate={candidate}
      />
    </Modal>
  );
};
